import React from 'react';
import { Button } from '@/components/ui/button';
import { Sparkles, AlertCircle } from 'lucide-react';

export default function AsaMutasiConfirm({ 
  oldAmount, 
  newAmount, 
  date,
  onConfirm, 
  onSkip,
  isProcessing 
}) {
  const fmt = (n) => new Intl.NumberFormat('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);
  const diff = newAmount - oldAmount;
  
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60  animate-in fade-in duration-200 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200 border border-amber-100">
        <div className="bg-gradient-to-br from-[#FFFDF3] to-[#FDF3D8] p-6 flex flex-col items-center text-center relative overflow-hidden border-b border-[#F6E9CC]">
          <div className="absolute top-[-50%] left-1/2 -translate-x-1/2 w-64 h-64 bg-white/40 blur-3xl rounded-full"></div>
          <div className="w-14 h-14 rounded-full bg-[#8C6208] flex items-center justify-center border-[4px] border-white mb-3 shadow-[0_8px_16px_rgba(140,98,8,0.2)] z-10">
            <Sparkles className="w-7 h-7 text-white" />
          </div>
          <h3 className="text-lg font-display font-bold text-[#6D4C06] relative z-10 tracking-wide">Halo! ASA di sini</h3>
        </div>
        
        <div className="p-6 text-slate-700">
          <p className="leading-relaxed mb-4 text-sm text-center">
            ASA melihat Anda baru saja <strong>mengedit biaya</strong>.
            <br />
            Apakah Anda juga ingin menyesuaikan catatan <strong>Mutasi Rekening</strong> sebelumnya?
          </p>

          <div className="bg-amber-50/50 rounded-xl p-4 mb-6 border border-amber-100/50 space-y-3">
            <div className="flex items-center justify-between text-sm">
              <span className="text-slate-500">Mutasi Sebelumnya:</span>
              <span className="font-semibold text-slate-700">Rp {fmt(oldAmount)}</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-slate-500">Mutasi Baru:</span>
              <span className="font-semibold text-slate-900">Rp {fmt(newAmount)}</span>
            </div>
            <div className="pt-2 border-t border-amber-200/50 flex items-center justify-between text-sm">
              <span className="text-amber-700 font-medium">Selisih yang disesuaikan:</span>
              <span className={`font-bold ${diff > 0 ? 'text-red-600' : 'text-green-600'}`}>
                {diff > 0 ? '+' : ''} Rp {fmt(diff)}
              </span>
            </div>
            <div className="pt-2 border-t border-amber-200/50 flex items-center gap-2 text-xs text-amber-700">
              <AlertCircle className="w-4 h-4 shrink-0" />
              <span>Dicatat pada tanggal: <strong>{date}</strong></span>
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              variant="outline"
              className="flex-1 border-slate-200 text-slate-600 hover:bg-slate-50 hover:text-slate-900 text-xs h-9"
              onClick={onSkip}
              disabled={isProcessing}
            >
              Jangan Ubah Mutasi
            </Button>
            <Button
              className="flex-1 bg-[#8C6208] hover:bg-[#704e06] text-white shadow-lg shadow-amber-900/10 text-xs h-9"
              onClick={onConfirm}
              disabled={isProcessing}
            >
              {isProcessing ? 'Menyimpan...' : 'Ya, Sesuaikan Mutasi'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
